export default class Leistung {
    /** PK: Identifikation der Leistung | erforderlich */
    public leistung_id: number | null = null;
    /** Code der Leistung | max. 20 Zeichen | erforderlich */
    public leistung: string | null = null;
    /** Bezeichnung der Leistung | max. 100 Zeichen | erforderlich */
    public bezeichnung: string | null = null;
    /** Preis der Leistung in EURO */
    public preis: number | null = null;
    /** Preis der Leistung in EURO (brutto) */
    public preis_brutto: number | null = null;
    /** MwSt.-Satz */
    public steuersatz: number | null = null;
    /** Erlöskonto | max. 10 Zeichen */
    public konto: string | null = null;
    /** Information zur Leistung | max. 50 Zeichen */
    public information: string | null = null;
    /** Leistung in PopUp zur Kassa zur Auswahl aktiv j/n | max. 1 Zeichen */
    public aktiv: string | null = 'n';
    /** Default Wert (j/n) für Auswahl der Leistung in PopUp zur Kassa | max. 1 Zeichen */
    public aktiv_default: string | null = 'n';
    /** wenn diese Leistung bereits in die Kartei eingetragen wurde (am selbenTag), dann keine Schnellauswahl der aktuellen Leistung */
    public leistung_id_inkludiert: number | null = null;
    /** Datensatz gültig j/n | max. 1 Zeichen | erforderlich */
    public gueltig: string | null = 'j';
    /** 0=keine HCW-Leistung, 1=immer HCW-Leistung */
    public hcw: string | null = null;
    /** Preis der Leistung in EURO (brutto) */
    public preis_mitarbeiter: number | null = null;
    /** Preis der Leistung in EURO (brutto) */
    public preis_rektorat: number | null = null;

    public leistung_id_inkludiert_bezeichnung: string | null = null;

    constructor(data?: Partial<Leistung>) {
        Object.assign(this, data);
    }
}
